import { notification } from "antd";

export const openNotification = message => {
  const args = {
    message: message,
    duration: 2,
    placement: "bottomRight",
  };
  notification.open(args);
};

export function validateEmail(email) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

export const getWhatsappMessage = resultList => {
  let phoneNumber = resultList.phonenumber;
  let message = `Hi! I'm Interested In ${resultList.projectName}. Please Share Details.`;

  message = message.split(" ").join("%20");

  const URL =
    "https://api.whatsapp.com/send?phone=" +
    phoneNumber +
    "&text=%20" +
    message;
  return URL;
};
